var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.5","d":"M8.00033 14.6667C7.26395 14.6667 6.66699 15.2637 6.66699 16C6.66699 16.7364 7.26395 17.3334 8.00033 17.3334H17.0003C17.7367 17.3334 18.3337 16.7364 18.3337 16C18.3337 15.2637 17.7367 14.6667 17.0003 14.6667H8.00033Z","fill":"#EA4C89","key":0}),React.createElement("path",{"d":"M15.0569 23.0572C14.5362 23.5779 14.5362 24.4222 15.0569 24.9428C15.5776 25.4635 16.4218 25.4635 16.9425 24.9428L24.9425 16.9428C25.4473 16.4381 25.4649 15.6253 24.9825 15.0991L17.6492 7.09907C17.1516 6.55625 16.3082 6.51958 15.7654 7.01717C15.2225 7.51476 15.1859 8.35818 15.6835 8.90101L22.1542 15.9599L15.0569 23.0572Z","fill":"#EA4C89","key":1})]);
}

ArrowRightInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
